module.exports = __webpack_public_path__ + "img/royal-hd.e5fa26a0.png";